import React, { Component } from 'react';
import Welcome from './Components/welcome/Welcome';

import './App.css';

class App extends Component {
  render() {
    return (
      <>
        <Welcome />
      </>
    );
  }
}

export default App;
